const sections = {
    'checkout': {
        'sectionEl': null,
        'linkElParent': null,
        'desktopVideo': null,
        'mobileVideo': null
    },
    'order-shipped': {
        'sectionEl': null,
        'linkElParent': null,
        'desktopVideo': null,
        'mobileVideo': null
    },
    'in-transit': {
        'sectionEl': null,
        'linkElParent': null,
        'desktopVideo': null,
        'mobileVideo': null
    },
    'delivered': {
        'sectionEl': null,
        'linkElParent': null,
        'desktopVideo': null,
        'mobileVideo': null
    },
    linkHolderEl: null,
    currBottomPadding: null,
    paddingIncrement: null,
    displayOrder: ["checkout", "order-shipped", "in-transit", "delivered"],
    currVisible: "checkout",
    nextVisible: "order-shipped",
    prevVisible: null
};

let fixed = false;
let startFixedEl,
    endFixedEl,
    fixedEl;

window.addEventListener("DOMContentLoaded", () => {
    startFixedEl = document.querySelector("#checkout");
    endFixedEl = document.querySelector("#delivered");
    fixedEl = document.querySelector("#sticky-section");

    if (startFixedEl && endFixedEl && fixedEl) {
        for (let slug in sections) {
            if (typeof(sections[slug]) == 'object' && !Array.isArray(sections[slug]) && sections[slug]) {
                sections[slug].sectionEl = document.querySelector("#" + slug);
                sections[slug].linkEl = document.querySelector('a[section-map="' + slug + '"]');
                
                if (sections[slug].linkEl) {
                    sections[slug].linkElParent = sections[slug].linkEl.parentElement;
                    sections[slug].desktopVideo = document.querySelector("#" + slug + "-video");
                    sections[slug].mobileVideo = document.querySelector("#" + slug + "-mobile-video");

                    sections[slug].linkEl.addEventListener("click", (e) => {
                        const targetSection = document.querySelector("#" + e.target.getAttribute("section-map"));
                        if (targetSection) {
                            window.scrollTo({
                                left: 0,
                                top: document.querySelector("#sticky-container").offsetTop + targetSection.offsetTop,
                                behavior: "smooth"
                            });
                        }
                    });
                }
            }
        }

        sections.linkHolderEl = document.querySelector("#link-holder-el");
        sections.currBottomPadding = 0;
        sections.paddingIncrement = 33;

        setTimeout(() => {
            let windowScroll = window.scrollY;
            if (windowScroll <= (document.querySelector("#sticky-container").offsetTop + endFixedEl.offsetTop) && windowScroll >= (document.querySelector("#sticky-container").offsetTop + startFixedEl.offsetTop)) {
                window.scrollTo(0, document.querySelector("#sticky-container").offsetTop);
                setTimeout(() => {
                    window.scrollTo(0, windowScroll);
                }, 1000);
            }
        }, 500);
    }
});

window.addEventListener("scroll", (e) => {
    if (startFixedEl && endFixedEl && fixedEl) {
        if ( !fixed ){
            if (startFixedEl.getBoundingClientRect().top <= 0 && startFixedEl.getBoundingClientRect().top >= -500) {
                fixed = true;
                fixedEl.style.position = "fixed";
                fixedEl.style.top = 0;
                fixedEl.style.bottom = null;
                // document.querySelector("html").classList.add("force_smooth-scroll");
            }
            if (endFixedEl.getBoundingClientRect().top >= 0 && endFixedEl.getBoundingClientRect().top <= 500) {
                fixed = true;
                fixedEl.style.position = "fixed";
                fixedEl.style.top = 0;
                fixedEl.style.bottom = null;
                // document.querySelector("html").classList.add("force_smooth-scroll");
            }
        } else {
            if (endFixedEl.getBoundingClientRect().top <= 0) {
                fixed = false;
                fixedEl.style.position = "absolute";
                fixedEl.style.top = null;
                fixedEl.style.bottom = 0;
                // document.querySelector("html").classList.remove("force_smooth-scroll");
            }
            if (startFixedEl.getBoundingClientRect().top >= 0) {
                fixed = false;
                fixedEl.style.position = "absolute";
                fixedEl.style.top = 0;
                fixedEl.style.bottom = null;
                // document.querySelector("html").classList.remove("force_smooth-scroll");
            }
        }

        if(sections.nextVisible && sections[sections.nextVisible].sectionEl.getBoundingClientRect().top >= -350 && sections[sections.nextVisible].sectionEl.getBoundingClientRect().top <= 350) {
            if (getComputedStyle(sections[sections.currVisible].mobileVideo).display != "none") {
                sections[sections.currVisible].mobileVideo.pause();
                sections[sections.currVisible].sectionEl.classList.remove("is-active");
            } else {
                sections[sections.currVisible].linkElParent.classList.remove("is-active");
                sections[sections.currVisible].desktopVideo.classList.remove("is-active");
                sections[sections.currVisible].desktopVideo.pause();
            }
            

            switch (sections.currVisible) {
                case sections.displayOrder[0]:
                    sections.prevVisible = sections.displayOrder[0];
                    sections.currVisible = sections.displayOrder[1];
                    sections.nextVisible = sections.displayOrder[2];
                    break;
                case sections.displayOrder[1]:
                    sections.prevVisible = sections.displayOrder[1];
                    sections.currVisible = sections.displayOrder[2];
                    sections.nextVisible = sections.displayOrder[3];
                    break;
                case sections.displayOrder[2]:
                    sections.prevVisible = sections.displayOrder[2];
                    sections.currVisible = sections.displayOrder[3];
                    sections.nextVisible = null;
                    break;
            }

            if (getComputedStyle(sections[sections.currVisible].mobileVideo).display != "none") {
                sections[sections.currVisible].mobileVideo.play();
                sections[sections.currVisible].sectionEl.classList.add("is-active");
            } else {
                sections[sections.currVisible].desktopVideo.play();
                sections[sections.currVisible].desktopVideo.classList.add("is-active");
                sections[sections.currVisible].linkElParent.classList.add("is-active");

                sections.currBottomPadding += sections.paddingIncrement;
                sections.linkHolderEl.style.paddingBottom = (sections.currBottomPadding/10) + "rem";
            }
        } else if (sections.prevVisible && sections[sections.prevVisible].sectionEl.getBoundingClientRect().top <= 350 && sections[sections.prevVisible].sectionEl.getBoundingClientRect().top >= -350) {
            if (getComputedStyle(sections[sections.currVisible].mobileVideo).display != "none") {
                sections[sections.currVisible].mobileVideo.pause();
                sections[sections.currVisible].sectionEl.classList.remove("is-active");
            } else {
                sections[sections.currVisible].linkElParent.classList.remove("is-active");
                sections[sections.currVisible].desktopVideo.classList.remove("is-active");
                sections[sections.currVisible].desktopVideo.pause();
            }

            switch (sections.currVisible) {
                case sections.displayOrder[1]:
                    sections.prevVisible = null;
                    sections.currVisible = sections.displayOrder[0];
                    sections.nextVisible = sections.displayOrder[1];
                    break;
                case sections.displayOrder[2]:
                    sections.prevVisible = sections.displayOrder[0];
                    sections.currVisible = sections.displayOrder[1];
                    sections.nextVisible = sections.displayOrder[2];
                    break;
                case sections.displayOrder[3]:
                    sections.prevVisible = sections.displayOrder[1];
                    sections.currVisible = sections.displayOrder[2];
                    sections.nextVisible = sections.displayOrder[3];
                    break;
            }

            if (getComputedStyle(sections[sections.currVisible].mobileVideo).display != "none") {
                sections[sections.currVisible].mobileVideo.play();
                sections[sections.currVisible].sectionEl.classList.add("is-active");
            } else {
                sections[sections.currVisible].desktopVideo.play();
                sections[sections.currVisible].desktopVideo.classList.add("is-active");
                sections[sections.currVisible].linkElParent.classList.add("is-active");

                sections.currBottomPadding -= sections.paddingIncrement;
                sections.linkHolderEl.style.paddingBottom = (sections.currBottomPadding/10) + "rem";
            }
        } else if (!sections.prevVisible && sections[sections.currVisible].sectionEl.getBoundingClientRect().top >= -350 && sections[sections.currVisible].sectionEl.getBoundingClientRect().top <= 350) {
            if (getComputedStyle(sections[sections.currVisible].mobileVideo).display != "none") {
                sections[sections.currVisible].mobileVideo.play();
            } else {
                sections[sections.currVisible].desktopVideo.play();
                sections[sections.currVisible].desktopVideo.classList.add("is-active");
                sections[sections.currVisible].linkElParent.classList.add("is-active");
                sections.currBottomPadding = 0
                sections.linkHolderEl.style.paddingBottom = (sections.currBottomPadding/10) + "rem";
            }
        }  else if (!sections.nextVisible && sections[sections.currVisible].sectionEl.getBoundingClientRect().top <= 350 && sections[sections.currVisible].sectionEl.getBoundingClientRect().top >= -350) {
            if (getComputedStyle(sections[sections.currVisible].mobileVideo).display == "none") {
                sections.currBottomPadding = sections.paddingIncrement * (sections.displayOrder.length - 1);
                sections.linkHolderEl.style.paddingBottom = (sections.currBottomPadding/10) + "rem";
            }
        }
    }
});